/**
 * 
 * NavMobile.js
 * 
 */
export default class NavMobile {

    constructor() {
        this.name = 'NavMobile';
        this.siteContent            = document.querySelector('.site');
        this.siteContentCover       = document.querySelector('.nav__cover--mobile');
        this.slideMenuBtn           = document.querySelector('.nav__burger');
        this.slideMenuCloseBtn      = document.createElement("div");
        this.menuToSlide            = document.querySelector('.menu-wrapper');
        this.menuWrapperScroll      = document.querySelector('.menu-wrapper-scroll');
        this.btnsWithSubMenus       = document.querySelectorAll('.menu-item-has-children');
        this.menuWidth              = this.menuToSlide.offsetWidth;
        this.menuOpen               = false;
        this.isReset                = true;
        this.enabled                = true;
        this.onSlideSubMenuClosedRef;
        this.onAnimationCompleteRef;
        this.body                   = document.getElementsByTagName('body')[0];
        this.HTML                   = document.getElementsByTagName('html')[0];

        this._init();
    }

    // Public Functions
    resetMenu () {
        //console.log('NavMobile.js: resetMenu()');
        if (this.menuOpen) {
            this._toggleSlideMenu();
            this._onSlideMenuClosed();
            this._onAnimationComplete();
            this._onSlideMenuClosed();
        }
        this.isReset = true;
    }

    enable () {
        this.enabled = true;
    }

    disable () {
        this.enabled = false;
    }

    // Getters / Setters
    get reset() {
        return this.isReset;
    }

    set reset($val) {
        this.isReset = $val;
    }
    
    // 'Private' Functions
    _init() {
        //console.log('NavMobile.js: this.menuWidth', this.menuWidth);
        // Add close btn to menu
        this.slideMenuCloseBtn.setAttribute('class', 'nav__close-btn');
        this.menuToSlide.appendChild(this.slideMenuCloseBtn);

        // Add click listeners
        this.slideMenuBtn.addEventListener('click', () => {
            this._toggleSlideMenu();
        });
        
        this.siteContentCover.addEventListener('click', () => {
            this._toggleSlideMenu();
        });

        this.slideMenuCloseBtn.addEventListener('click', () => {
            this._toggleSlideMenu();
        });

        // Add click listeners to menu items with submenus
        for (let i = 0; i < this.btnsWithSubMenus.length; ++i) {
            this.btnsWithSubMenus[i].addEventListener('click', (e) => {
                if (e.target.tagName.toLowerCase() === 'a') {
                    this._openSlideSubMenu(e.currentTarget.querySelector('.sub-menu'));
                }
            });
        }
    }

    _toggleSlideMenu() {
        if (this.enabled) {
            //console.log('NavMobile: _toggleSlideMenu');
            if (!this.menuOpen) {
                this.menuOpen = true;
                this.isReset = false;
                this.menuToSlide.classList.add('animated');
                this.menuToSlide.style.transform = 'translateX(0)';
                this.siteContentCover.classList.add('fadein');
                this.siteContentCover.classList.remove('fadeout');
                this.body.classList.add('noscroll');
                this.HTML.classList.add('noscroll');
            } else {
                this.menuOpen = false;
                this.menuToSlide.classList.add('animated');
                this.menuToSlide.style.transform = 'translateX(calc(100% + 50px))';
                this.siteContentCover.classList.remove('fadein');
                this.siteContentCover.classList.add('fadeout');

                this.onSlideSubMenuClosedRef = this._onSlideMenuClosed.bind(this);
                this.siteContentCover.addEventListener('transitionend', this.onSlideSubMenuClosedRef);
            }
            this.onAnimationCompleteRef = this._onAnimationComplete.bind(this);
            this.menuToSlide.addEventListener('transitionend', this.onAnimationCompleteRef);
        }
    }
    
    _onAnimationComplete() {
        //console.log('NavMobile.js: _onAnimationComplete');
        this.menuToSlide.classList.remove('animated');
        this.menuToSlide.removeEventListener('transitionend', this.onAnimationCompleteRef);
    }

    _onSlideMenuClosed() {
        //console.log('NavMobile.js: _onSlideSubMenuClosed');
        let backBtn = document.querySelector('.sub-menu.active .back-btn');
        if (backBtn) {
            this._closeSlideSubMenu(document.querySelector('.sub-menu.active'), document.querySelector('.sub-menu.active .back-btn'));
        }
        this.siteContentCover.classList.remove('fadeout');
        this.siteContentCover.removeEventListener('transitionend', this.onSlideSubMenuClosedRef);

        // make body and html scrollable again
        this.body.classList.remove('noscroll');
        this.HTML.classList.remove('noscroll');
    }

    _openSlideSubMenu($menu) {
        if (this.enabled) {
            //console.log('NavMobile.js: _openSlideSubMenu');
            $menu.classList.add('active');

            let backBtn = document.createElement("span");
            
            backBtn.setAttribute('class', 'back-btn');
            backBtn.innerHTML = "BACK";
            backBtn.addEventListener('click', (e) => {
                this._closeSlideSubMenu($menu, backBtn);
            });

            $menu.appendChild(backBtn);

            setTimeout(() => {
                this._removeMenuWrapperScroll();
            }, 500);
        }
    }

    _closeSlideSubMenu($menu, backBtn) {
        if (this.enabled) {
            //console.log('NavMobile.js: _closeSlideSubMenu');
            $menu.removeChild(backBtn);
            $menu.classList.remove('active');

            this._addMenuWrapperScroll();
        }
    }

    _removeMenuWrapperScroll() {
        // prevent scrolling in main nav wrapper
        this.menuWrapperScroll.classList.add('noscroll');
    }

    _addMenuWrapperScroll() {
        // resume scrolling in main nav wrapper
        this.menuWrapperScroll.classList.remove('noscroll');
    }
}
